import React, { useEffect, useState } from 'react';
import { Control } from 'components/common/ControlManager';
import { Files } from 'helpers/FileHelpers';
import { Code } from 'constants/codes';
import { Hooks } from 'helpers/ListImports';
import { Utility } from 'helpers/UtilityHelpers';


interface ControlSessionProps {
  startDate: string;
  setStartDate: (value: string) => void;
  endDate: string;
  setEndDate: (value: string) => void;
}

export const ControlSession: React.FC<ControlSessionProps> = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) => {
  
  const [error, setError] = useState<string | null>(null);
  const [sessionOptions, setSessionOptions] = Hooks.Form.Options();
  const [dateVisible, setDateVisible] = useState<boolean>(false);
  const [sessionId, setSessionId] = useState<number | null>(Code.Option.Session.ALL);

  useEffect(() => {
    Files.Json.Http(Code.Form.Name.SESSIONALL, Code.Option.Common.NOTHING, setSessionOptions, setError);
  }, []);

  useEffect(() => {
    setDateVisible(sessionId === Code.Option.Session.CUSTOM);

    const range = Utility.Get.DateRange(sessionId);
    if (range) {
      setStartDate(Utility.Format.Date(range.startDate,Code.Format.DateTime.Date));
      setEndDate(Utility.Format.Date(range.endDate,Code.Format.DateTime.Date));
    }
  }, [sessionId]);
  

  return (
    <>
      <Control.Dropdown title={"Session"} value={sessionId} options={sessionOptions} onChange={setSessionId} />
      {dateVisible && (
        <>
          <Control.SessionDate title={"Start Date"} value={new Date(startDate + 'T10:00:00')} onChange={(e) => setStartDate(e.target.value)} />
          <Control.SessionDate title={"End Date"} value={new Date(endDate + 'T10:00:00')} onChange={(e) => setEndDate(e.target.value)} />
        </>
      )}
    </>
  );
};